"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = guessOrderingConfig;
var _startCase2 = _interopRequireDefault(require("lodash/startCase"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CANDIDATES = ['title', 'name', 'label', 'heading', 'header', 'caption', 'description'];
var PRIMITIVES = ['string', 'boolean', 'number'];
var isPrimitive = function isPrimitive(field) {
  return PRIMITIVES.includes(field.type);
};
function guessOrderingConfig(objectTypeDef) {
  var candidates = CANDIDATES.filter(function (candidate) {
    return objectTypeDef.fields.some(function (field) {
      return isPrimitive(field) && field.name === candidate;
    });
  }); // None of the candidates were found, fallback to all fields

  if (candidates.length === 0) {
    candidates = objectTypeDef.fields.filter(isPrimitive).map(function (field) {
      return field.name;
    });
  }
  return candidates.map(function (name) {
    return {
      name: name,
      title: (0, _capitalize2.default)((0, _startCase2.default)(name)),
      by: [{
        field: name,
        direction: 'asc'
      }]
    };
  });
}